import { render, staticRenderFns } from "./EbbyLiveChat.vue?vue&type=template&id=3636c4c2&scoped=true&"
import script from "./EbbyLiveChat.vue?vue&type=script&lang=ts&"
export * from "./EbbyLiveChat.vue?vue&type=script&lang=ts&"
import style0 from "./EbbyLiveChat.vue?vue&type=style&index=0&id=3636c4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636c4c2",
  null
  
)

export default component.exports